import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, product }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-400 gap-2">
        <Loader2 className="h-5 w-5 animate-spin" /> Loading…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  const acct = user.account_type || "business";
  if (product === "personal" && acct !== "personal") return <Navigate to="/dashboard" replace />;
  if (product === "business" && acct === "personal") return <Navigate to="/pa" replace />;
  return children;
}
